import gql from 'graphql-tag'

export const deleteDataRecord = gql`
  mutation DeleteDataRecord($id: ID!, $table: String!) {
    deleteDataRecord(input: {id: $id, table: $table}) {
      errors
    }
  }
`
